import React, { useState, useEffect } from 'react';

import { Row, Col } from 'react-bootstrap';
import SkyPulseTable from 'components/SkyPulseTable';
import UsageFilter from '../UsageFilter';
import { getUTCShortDate } from 'utils';
import { WeekOptions, defaultUsageFilters } from 'constants';

import styles from './styles.module.css';

const columnDefinitions = [
  {
    name: 'Rank',
    key: 'rank',
    size: 'xsmall',
    sortable: true,
    dataCyClassName: 'Usage-MovieTableColumn-rank',
  },
  {
    name: 'Title',
    key: 'title',
    size: 'small',
    sortable: true,
    dataCyClassName: 'Usage-MovieTableColumn-title',
  },
  {
    name: 'Passengers',
    key: 'passengers',
    size: 'xsmall',
    sortable: true,
    dataCyClassName: 'Usage-MovieTableColumn-passengers',
  },
  {
    name: 'Passenger pool %',
    key: 'passenger_pool_per',
    size: 'small',
    className: styles.colWidth,
    sortable: true,
    dataCyClassName: 'Usage-MovieTableColumn-passengerPoolPer',
  },
  {
    name: 'Total view minutes',
    key: 'total_views_minutes',
    size: 'small',
    className: styles.colWidth,
    sortable: true,
    dataCyClassName: 'Usage-MovieTableColumn-totalViewsMin',
  },
  {
    name: 'Avg view minutes',
    key: 'avg_view_minutes',
    size: 'small',
    className: styles.colWidth,
    sortable: true,
    dataCyClassName: 'Usage-MovieTableColumn-avgViewmin',
  },
  {
    name: 'Title length',
    key: 'title_length',
    size: 'xsmall',
    sortable: true,
    dataCyClassName: 'Usage-MovieTableColumn-titleLength',
  },
];

const data = [
  {
    rank: '1',
    title: 'Tina',
    passengers: {
      display: '39,020',
      sort: 39020,
    },
    passenger_pool_per: '13.8%',
    total_views_minutes: {
      display: '7,178,080',
      sort: 7178080,
    },
    avg_view_minutes: 104,
    title_length: 114,
  },
  {
    rank: '2',
    title: '27 Dresses',
    passengers: {
      display: '66,060',
      sort: 66060,
    },
    passenger_pool_per: '13.2%',
    total_views_minutes: {
      display: '6,011,460',
      sort: 6011460,
    },
    avg_view_minutes: 91,
    title_length: 100,
  },
  {
    rank: '3',
    title: 'Hannah Montana The Movie',
    passengers: {
      display: '56,480',
      sort: 56480,
    },
    passenger_pool_per: '11.3%',
    total_views_minutes: {
      display: '6,551,680',
      sort: 6551680,
    },
    avg_view_minutes: 116,
    title_length: 127,
  },
  {
    rank: '4',
    title: 'Whale Riders',
    passengers: {
      display: '52,260',
      sort: 52260,
    },
    passenger_pool_per: '10.5%',
    total_views_minutes: {
      display: '6,009,900',
      sort: 6009900,
    },
    avg_view_minutes: 115,
    title_length: 126,
  },
  {
    rank: '5',
    title: 'Mamma Mia! Here We Go Again',
    passengers: {
      display: '51,7000',
      sort: 51700,
    },
    passenger_pool_per: '10.3%',
    total_views_minutes: {
      display: '6,204,000',
      sort: 6204000,
    },
    avg_view_minutes: 120,
    title_length: 132,
  },
  {
    rank: '6',
    title: 'The Ghost of Lord Farquaad',
    passengers: {
      display: '48,300',
      sort: 48300,
    },
    passenger_pool_per: '9.7%',
    total_views_minutes: {
      display: '4,588,500',
      sort: 4588500,
    },
    avg_view_minutes: 95,
    title_length: 104,
  },
  {
    rank: '7',
    title: 'Zoolander',
    passengers: {
      display: '41,300',
      sort: 41300,
    },
    passenger_pool_per: '8.3%',
    total_views_minutes: {
      display: '5,241,000',
      sort: 5241000,
    },
    avg_view_minutes: 127,
    title_length: 139,
  },
  {
    rank: '8',
    title: 'Media ID',
    passengers: {
      display: '36,960',
      sort: 36960,
    },
    passenger_pool_per: '7.4%',
    total_views_minutes: {
      display: '3,141,600',
      sort: 3141600,
    },
    avg_view_minutes: 85,
    title_length: 93,
  },
  {
    rank: '9',
    title: 'The Stage',
    passengers: {
      display: '35,420',
      sort: 35420,
    },
    passenger_pool_per: '7.1%',
    total_views_minutes: {
      display: '3,612,840',
      sort: 3612840,
    },
    avg_view_minutes: 102,
    title_length: 112,
  },
  {
    rank: '10',
    title: 'Far Far Away Idol',
    passengers: {
      display: '33,080',
      sort: 33080,
    },
    passenger_pool_per: '6.6%',
    total_views_minutes: {
      display: '3,936,520',
      sort: 3936520,
    },
    avg_view_minutes: 119,
    title_length: 130,
  },
  {
    rank: '11',
    title: 'Genres',
    passengers: {
      display: '29,720',
      sort: 29720,
    },
    passenger_pool_per: '5.9%',
    total_views_minutes: {
      display: '2,914,520',
      sort: 2914520,
    },
    avg_view_minutes: 98,
    title_length: 107,
  },
  {
    rank: '12',
    title: '3 Idiots',
    passengers: {
      display: '29,240',
      sort: 29240,
    },
    passenger_pool_per: '5.8%',
    total_views_minutes: {
      display: '4,152,080',
      sort: 4152080,
    },
    avg_view_minutes: 142,
    title_length: 156,
  },
];

const Movies = () => {
  const [filterData, setFilterData] = useState(data);
  const [filters, setFilters] = useState(defaultUsageFilters);

  useEffect(() => {
    const { searchText } = filters;
    const filteredData = data.filter((obj) => {
      return obj.title.toLowerCase().startsWith(searchText?.toLowerCase());
    });
    setFilterData(filteredData);
  }, [filters]);

  const week = WeekOptions[filters.week];
  const options = { month: 'short', day: 'numeric' };
  return (
    <Row className={styles.root} noGutters>
      <Col>
        <Row className={styles.title} noGutters>
          <Col data-cy-id="Usage-Movie" className="title_1">
            Movies
          </Col>
        </Row>
        <Row noGutters>
          <UsageFilter
            onFilterClick={(filters) => {
              setFilters(filters);
            }}
            onClear={(filters) => {
              setFilters(filters);
            }}
          />
        </Row>
        <Row className={styles.dataContainer} noGutters>
          <Col className="h-100">
            <Row className={styles.tableContainer} noGutters>
              <Col className="h-100">
                <SkyPulseTable
                  columns={columnDefinitions}
                  rows={filterData}
                  title={
                    <Row>
                      <Col>
                        {filters.option === 'week'
                          ? `Week of:
                          ${new Date(week?.startDt).toLocaleDateString(
                            'en-US',
                            options,
                          )}
                          -
                          ${new Date(week?.endDt).toLocaleDateString(
                            'en-US',
                            options,
                          )}
                          , ${new Date(week?.endDt).getFullYear()}`
                          : `Starting ${getUTCShortDate(
                              filters.startingDt,
                            )}, for ${filters.noOfDays} ${
                              filters.noOfDays === 1 ? 'day' : 'days'
                            }`}
                      </Col>
                      <Col md="auto">
                        Pool: <b>500,145</b> passengers used system
                      </Col>
                    </Row>
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Movies;
